import { render, staticRenderFns } from "./TopluTakipTarihi.vue?vue&type=template&id=2aab1854&scoped=true"
import script from "./TopluTakipTarihi.vue?vue&type=script&lang=ts"
export * from "./TopluTakipTarihi.vue?vue&type=script&lang=ts"
import style0 from "./TopluTakipTarihi.vue?vue&type=style&index=0&id=2aab1854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab1854",
  null
  
)

export default component.exports